import React, { useEffect, useState } from "react";
import "./salesByCategoryPieChart.scss";
import orderStore from "../../../stores/orderStore";
import productStore from "../../../stores/productStore";
import categoryStore from "../../../stores/categoryStore";
import { ResponsivePie } from "@nivo/pie";
import { Skeleton, useMediaQuery } from "@mui/material";

const pieColor = [
  "#488f31",
  "#75a760",
  "#9fc08f",
  "#c8d8bf",
  "#f1f1f1",
  "#f1c6c6",
  "#ec9c9d",
  "#e27076",
  "#d43d51",
];

const SalesByCategoryPieChart = () => {
  const max_width1200 = useMediaQuery("(max-width:1200px)");
  const max_width700 = useMediaQuery("(max-width:700px)");

  const OrderStore = orderStore();
  const ProductStore = productStore();
  const CategoryStore = categoryStore();

  const [saleByCategoryData, setSaleByCategoryData] = useState(null);

  useEffect(() => {
    if (
      !ProductStore.isLoading &&
      !OrderStore.isLoading &&
      !CategoryStore.isLoading
    ) {
      let data = [];
      CategoryStore.mCategory.map((category) => {
        data.push({
          id: category.categoryName,
          label: category.categoryName,
          value: 0,
          color: "",
        });
      });

      if (OrderStore.orderDetail) {
        OrderStore.orderDetail.map((order) => {
          ProductStore.mProduct.map((product) => {
            if (order.productID === product._id) {
              CategoryStore.mCategory.map((category) => {
                if (product.categoryID === category._id) {
                  data.find((c, i) => {
                    if (c.label === category.categoryName) {
                      c.value = c.value + 1;
                      c.color = pieColor[i];
                    }
                  });
                }
              });
            }
          });
        });
      }

      setSaleByCategoryData(data);
    }
  }, [ProductStore.isLoading, OrderStore.isLoading, CategoryStore.isLoading, ProductStore.mProduct, OrderStore.orderDetail, CategoryStore.mCategory]);

  return (
    <div className="sales-by-category-pie-chart">
      {saleByCategoryData ? (
        <ResponsivePie
          data={saleByCategoryData}
          theme={{
            axis: {
              domain: {
                line: {
                  stroke: "#171717",
                  strokeWidth: 1,
                },
              },
              legend: {
                text: {
                  fill: "#171717",
                },
              },
              ticks: {
                line: {
                  stroke: "#171717",
                  strokeWidth: 1,
                },
                text: {
                  fill: "#171717",
                },
              },
            },
            legends: {
              text: {
                fill: "#171717",
              },
            },
            tooltip: {
              container: {
                color: "#171717",
              },
            },
          }}
          colors={{ datum: "data.color" }}
          margin={{
            top: !max_width700 && max_width1200 ? 40 : 10,
            right: !max_width700 && max_width1200 ? 50 : 10,
            bottom: !max_width700 && max_width1200 ? 70 : 10,
            left: !max_width700 && max_width1200 ? 50 : 10,
          }}
          sortByValue={true}
          innerRadius={0.45}
          activeOuterRadiusOffset={8}
          borderWidth={1}
          borderColor={{
            from: "color",
            modifiers: [["darker", 0.2]],
          }}
          enableArcLinkLabels={!max_width700 && max_width1200 ? true : false}
          arcLinkLabelsSkipAngle={10}
          arcLinkLabelsTextColor={"#171717"}
          arcLinkLabelsThickness={2}
          arcLinkLabelsColor={{ from: "color" }}
          arcLabelsSkipAngle={10}
          arcLabelsTextColor={{
            from: "color",
            modifiers: [["darker", 2]],
          }}
          legends={
            max_width1200 &&
            !max_width700 && [
              {
                anchor: "bottom",
                direction: "row",
                justify: false,
                translateX: 20,
                translateY: 50,
                itemsSpacing: 0,
                itemWidth: 100,
                itemHeight: 18,
                itemTextColor: "#999",
                itemDirection: "left-to-right",
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: "circle",
                effects: [
                  {
                    on: "hover",
                    style: {
                      itemTextColor: "#000",
                    },
                  },
                ],
              },
            ]
          }
        />
      ) : (
        <Skeleton variant="rounded" width="100%" height="70%" sx={{ mt: 7 }} />
      )}
    </div>
  );
};

export default SalesByCategoryPieChart;
